export type JobExecutionStatus = JOB_EXECUTION_STATUS;

export enum JOB_EXECUTION_STATUS {
  queued = 'queued',
  terminated = 'terminated',
  successfullyCompleted = 'successfully-completed',
  running = 'running',
  errored = 'errored',
  taskFailedToStart = 'task-failed-to-start',
}
